package com.downdogapp.client.controllers

import com.downdogapp.client.Strings
import com.downdogapp.client.ViewController
import com.downdogapp.client.api.ChallengeEnrollRequest
import com.downdogapp.client.api.ChallengeEnrollResponse
import com.downdogapp.client.singleton.AlertAction
import com.downdogapp.client.singleton.App
import com.downdogapp.client.singleton.Network
import com.downdogapp.client.views.ChallengeEnrollView

class ChallengeEnrollViewController(
  title: String,
  subtitle: String,
  buttonText: String,
  private val defaultEmailNotifications: Boolean,
  private val defaultPushNotifications: Boolean,
  private val defaultChallengeUpdateEmails: Boolean,
  private val emailUnsubscribed: Boolean
) : ViewController() {

  override val view =
    ChallengeEnrollView(
      title = title,
      subtitle = subtitle,
      buttonText = buttonText,
      defaultDailyEmailNotifications = defaultEmailNotifications,
      defaultDailyPushNotifications = defaultPushNotifications,
      defaultChallengeUpdateEmails = defaultChallengeUpdateEmails,
      controller = this
    )

  override fun onViewBecameVisible() {
    if (!(defaultEmailNotifications || defaultPushNotifications || defaultChallengeUpdateEmails)) {
      App.alert(message = Strings.CHALLENGE_NO_MESSAGING_ENABLED_ALERT_TEXT)
    }
  }

  fun enroll(
    dailyEmailNotifications: Boolean,
    dailyPushNotifications: Boolean,
    challengeUpdateEmails: Boolean,
    callback: (String) -> Unit
  ) {
    fun post() {
      view.spinnerShowing = true
      Network.post(
        ChallengeEnrollRequest(
          dailyEmailNotifications = dailyEmailNotifications,
          dailyPushNotifications = dailyPushNotifications,
          challengeUpdateEmails = challengeUpdateEmails
        )
      ) { json ->
        val response = json?.let { ChallengeEnrollResponse.fromJson(it) }
        view.spinnerShowing = false
        if (response != null) {
          callback(response.message)
        } else {
          App.alertNoInternet()
        }
      }
    }

    when {
      emailUnsubscribed && (challengeUpdateEmails || dailyEmailNotifications) -> {
        App.alert(
          message = Strings.CHALLENGE_RESUBSCRIBE_TO_EMAILS_ALERT_TEXT,
          negativeButton = AlertAction(Strings.CANCEL) {
            view.spinnerShowing = false
            view.disableEmailNotifications()
          },
          positiveButton = AlertAction(Strings.OK) { post() }
        )
      }

      !(dailyEmailNotifications || dailyPushNotifications || challengeUpdateEmails) -> {
        App.alert(
          title = Strings.CHALLENGE_NO_MESSAGING_ENABLED_ALERT_TITLE,
          message = Strings.CHALLENGE_NO_MESSAGING_ENABLED_ALERT_TEXT,
          negativeButton = AlertAction(Strings.CANCEL) {
            view.spinnerShowing = false
          },
          positiveButton = AlertAction(Strings.OK) { post() }
        )
      }

      else -> {
        post()
      }
    }
  }
}
